module.exports = __webpack_public_path__ + "static/media/icon-lojas.9b8658be.svg";